/* ============================================================================
   Sparkline. 12 puntos, sin ejes, el punto actual en acento.
   Es un adorno informativo del stat tile: nunca la única forma de leer el valor.
   ========================================================================== */

import { linePath, linearScale, niceExtent } from './primitives'

export interface SparklineProps {
  values: number[]
  /** Color del trazo. Por omisión, tinta atenuada. */
  color?: string
  /** Color del punto final. */
  accent?: string
  width?: number
  height?: number
}

export function Sparkline({
  values,
  color = 'var(--ink-3)',
  accent = 'var(--accent)',
  width = 88,
  height = 28,
}: SparklineProps) {
  const clean = values.filter((v) => Number.isFinite(v))
  if (clean.length < 2) return null

  const pad = 4
  const extent = niceExtent(clean, { pad: 0.08 })
  const x = linearScale([0, clean.length - 1], [pad, width - pad])
  const y = linearScale([extent.min, extent.max], [height - pad, pad])
  const pts = clean.map((v, i) => ({ x: x(i), y: y(v) }))
  const last = pts[pts.length - 1]!

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      focusable="false"
      className="sparkline"
    >
      <path d={linePath(pts)} fill="none" stroke={color} strokeWidth={1.75} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last.x} cy={last.y} r={2.75} fill={accent} stroke="var(--surface-1)" strokeWidth={1.5} />
    </svg>
  )
}
